import * as angular from 'angular';
import {IController, IIntervalService, IScope, ITimeoutService} from 'angular';
import {AgentsService} from "../../../agents/services/agents-service.service";
import {AnalyticsService} from "../../../commons/services/analytics-service.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {$agentFactory} from "../../../agents/$agent.factory";
import {DeliveriesAlertsService} from "../../services/deliveries-alerts.service";
import {DeliveriesService} from "../../services/deliveries-service.service";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {Subscription} from "rxjs";
import {LocationsFacadeService} from "../../../commons/angular/services/locations/locations-facade.service";
import {LocationModel} from "../../../commons/models/location.model";
import {LocationHolderType} from "../../../commons/types/locationHolder.type";

export class DeliveryDetailedViewCtrl implements IController {
  delivery: any;
  agentId: any;
  serviceAreas: any[];

  private agentLocationRef: any;
  private intervalRef: any;
  private readonly PULLING_INTERVAL: any = 15000;

  private siteInfo: any;
  private deliveriesRef: any;
  private serviceAreasRef: any;
  public offlineEnabled: boolean;
  private isMapEnabled: any;
  private showHistoryMarkers: any;
  private selectedAction: any;
  private currentNavItem: any;
  public isShowMap: any;
  public isSuperOwner: boolean;
  public agentLocationSubscription: Subscription;


  /* @ngInject */
  constructor(private $deliveries, private $scope: IScope, private $state, private deliveriesAlertsService: DeliveriesAlertsService,
              private deliveriesService: DeliveriesService, private $agent: $agentFactory, private $log, private $agentLocation, private $mdMedia, private $serviceArea,
              private $interval: IIntervalService, private splitService: SplitService, private agentsService: AgentsService, private analyticsService: AnalyticsService,
              private siteContextService: SiteContextService, private IAMPermissions, private locationsFacadeService: LocationsFacadeService, private $timeout: ITimeoutService) {
    this.deliveriesRef = this.$deliveries();
    this.serviceAreasRef = this.$serviceArea();
    this.offlineEnabled = this.splitService.isOfflineEnabled();
  }

  $onInit() {
    this.siteInfo = this.siteContextService.getSiteInfo();
    this.isShowMap = this.siteInfo.showMap;
    this.isMapEnabled = false;
    this.currentNavItem = this.$state.current.url;
    this.isSuperOwner = this.IAMPermissions.hasRole('super.owner');


    if (!this.serviceAreas) {
      this._getServiceAreas();
    }

    // Barcode Event
    this.$scope.$on('barcode-scanned', (event, barcode) => {
      this.$log.debug('Scan detected, bar code is : ', barcode);
      this.barcodeQuery(barcode);
    });
  }

  $onChanges(changes) {
    if (changes.agentId) {
      if (this.isShowMap) {
        this._bindAgentLocation(this.agentId);
      }
    }
  };

  $doCheck() {
    if (this.$mdMedia('gt-md')) {
      this.isMapEnabled = false;
    }
    // this.showHistoryMarkers = this.$state.current.url === '/history';
    this.showHistoryMarkers = this.currentNavItem === '/history';
  };

  $onDestroy() {
    if (this.agentLocationRef) {
      this.agentLocationRef.$destroy();
    }

    if (this.intervalRef) {
      this.$interval.cancel(this.intervalRef);
    }

    this.locationsFacadeService.removeAllLocations();
    this.agentLocationSubscription?.unsubscribe();

  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  barcodeQuery(barcode) {
    this.deliveriesRef.$getAll({query: barcode})
      .then((deliveryIds) => {
        const deliveryId = deliveryIds[0];
        if (deliveryId) {
          this.deliveriesAlertsService.barcodeScanSuccess(barcode);
          this.$state.go('.', {id: deliveryId});
        } else {
          this.deliveriesAlertsService.barcodeScanError(barcode);
        }
      })
      .catch((error) => {
        this.$log.debug('Fail to barcode query, ' +
          'deliveryDetailedView@barcodeQuery', error);
      })
  }

  onToggleMap() {
    this.isMapEnabled = !this.isMapEnabled;
    this._bindAgentLocation(this.agentId);
  }

  toggleShowMap() {
    this.analyticsService.trackEvent('Delivery Actions', 'Show Map', 'Click');
    this.isShowMap = true;
    this._bindAgentLocation(this.agentId);
  }

  onSelectAction(action) {
    this.selectedAction = action;
  }

  private _getServiceAreas() {
    const serviceAreaIds = this.deliveriesService.getDeliveryServiceAreasIdsList(this.delivery);
    this.serviceAreasRef.$asyncValues(serviceAreaIds)
      .then((serviceAreas) => {
        this.serviceAreas = serviceAreas;
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Error while getting service areas from server, siteMarket Map \n' + error);
        }
      });
  }

  private _bindAgentLocation(agentId?: string) {

    if (!agentId) {
      return;
    }

    this.locationsFacadeService.getLocation(this.agentId, LocationHolderType.Agent);

    this.locationsFacadeService.subscribeToChannels();

    this.agentLocationSubscription = this.locationsFacadeService.selectLocation(this.agentId)
      .subscribe((updatedLocation: LocationModel) => {
        const agentCopy = angular.copy(this.delivery.agent);
        if (agentCopy) {
          agentCopy.lastKnownLocation = updatedLocation;
          this.delivery.agent = agentCopy;
        }

        // Update Angularjs Cycle
        this.$timeout(0).then(() => {
        });
      })

  }


}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveryDetailedView', {
    bindings: {
      delivery: '<',
      agentId: '<?',
      serviceAreas: '<?'
    },
    template: require('./delivery-detailed-view.html').default,
    controller: DeliveryDetailedViewCtrl
  });
